<template>
  <div>
    <!-- 工具栏 -->
    <div class="headtool">
      <div>佐证列表</div>
      <el-radio-group
        v-if="!disabled"
        v-model="uploadType"
        @input="uploadTypeChange"
      >
        <el-radio-button
          v-for="(item, key) in uploadTypes"
          :key="key"
          :label="item.value"
        >
          {{ item.title }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <!-- 上传代码 -->
    <div :class="disabled ? 'img-list_disabled' : 'img-list'">
      <!-- 上传文件列表 -->
      <div class="img-li-box" v-for="(item, key) in dataList" :key="key">
        <!-- 缩略图或图标 -->
        <img
          class="img-li-b--url"
          :src="
            WXPstAxios_BASE_URL +
            '/upload/getthumbnail/' +
            item.id +
            '?token=' +
            pstApi.getToken()
          "
        />
        <div class="img-li-b--bottom">
          <div class="img-li-b--name">{{ item.title }}</div>
          <el-button
            v-if="!disabled"
            type="text"
            @click="editContent(item, key)"
            >编辑</el-button
          >
        </div>
        <!-- 删除icon -->
        <div v-if="!disabled" class="img-li-b--delete">
          <i @click="deleteUpload(item, key)" class="el-icon-delete"></i>
        </div>
        <!-- 放大icon -->
        <div
          v-if="
            item.extName == '.JPG' ||
            item.extName == '.PNG' ||
            item.extName == '.MP4'
          "
          class="img-li-b--layer"
          @click="contentShow(item)"
        >
          <i class="el-icon-view"></i>
        </div>
      </div>
      <!-- 上传文件列表结束 -->
      <!-- 上传进度 -->
      <div v-if="!progShow" class="img-li-box img-li-b--progress">
        <el-progress type="circle" :percentage="progress"></el-progress>
      </div>
      <!-- :status="proStatus" -->
      <!-- 上传按钮 -->
      <div v-show="progShow" class="img-li-b--upload">
        <el-upload
          v-if="!disabled"
          class="img-li-b--upl--field"
          ref="upload"
          list-type="picture-card"
          :action="action"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="beforeUploadFile"
          :http-request="uploadFile"
          :accept="accept"
        >
          <el-button slot="trigger" size="small" type="primary"
            >选择{{ uploadTypes[uploadType].title }}</el-button
          >
        </el-upload>
      </div>
      <doc-viewer
        :show="docurls.length > 0 && fileExt != ''"
        :ext="fileExt"
        :urls="docurls"
        @close="docViewClose"
      />
      <el-drawer
        title="编辑文件信息"
        :before-close="handleClose"
        :visible.sync="isEditDoc"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
      >
        <div class="demo-drawer__content">
          <el-form :model="form">
            <el-form-item label="标题">
              <el-input v-model="form.title" autocomplete="off" />
            </el-form-item>
            <el-form-item label="排序值">
              <el-input v-model="form.ordernum" autocomplete="off" />
            </el-form-item>
            <el-form-item label="选项">
              <el-checkbox-group v-model="form.checkList">
                <el-checkbox v-if="form.isPrint" label="打印" />
                <el-checkbox
                  :disabled="form.contentType == 1"
                  v-if="form.isDownload"
                  label="下载"
                />
                <el-checkbox v-if="form.isPlay" label="自动播放" />
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <div class="demo-drawer__footer">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="$refs.drawer.closeDrawer()"
              >应 用</el-button
            >
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import SparkMD5 from "spark-md5";
// 导入组件
import DocViewer from "./DocViewer.vue";
export default {
  props: {
    uploadTypes: {
      type: Array,
      default: function () {
        return [
          { title: "图片", value: 0, fillterExt: "*.jpg,*.png" },
          { title: "视频", value: 1, fillterExt: "*.mp4" },
        ];
      },
    },
    nodeId: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    nodeId() {
      this.getUploads();
    },
  },
  components: {
    DocViewer,
  },
  data() {
    return {
      action: "''",
      accept: ".jpg,.png",
      progShow: true,
      progress: 0, //上传进度
      pass: null, //是否上传成功
      isEditDoc: false, //编辑文档对话框
      form: {
        id: "",
        title: "",
        ordernum: "",
        contentType: 0,
        checkList: [],
        //是否显示
        isPrint: false,
        isDownload: false,
        isPlay: false,
      },
      formLabelWidth: "80px",
      dataList: [],
      //文档预览参数
      docurls: [],
      ExtName: [],
      fileExt: "",
      uploadType: "0",
    };
  },
  created() {
    //这时不可调用，props[]中的值还没赋值
    //this.getUploads();
  },
  mounted() {
    this.getUploads();
  },
  methods: {
    uploadTypeChange(value) {
      // console.log(value);
      if (value == 0) {
        this.accept = ".jpg,.png";
      } else if (value == 1) {
        this.accept = ".mp4";
      }
    },
    getUploads() {
      if (this.nodeId == "") {
        return;
      }
      this.WXPstAxios({
        method: "get",
        url: "/upload/list/" + this.nodeId,
      })
        .then((res) => {
          this.dataList = res.data;
          this.$emit("uploadchange", this.dataList); //更新父组件中的uploadList
          //console.log("文件列表：", this.dataList);
        })
        .catch(() => {
          this.$toast("文件列表读取失败");
        });
    },
    //上传前进行校验
    beforeUploadFile(file) {
      var ext = this.Common.getFileExtension(file.name).toLocaleUpperCase();
      //console.log(ext)
      if (this.uploadType == 0 && (ext == "JPG" || ext == "PNG")) {
        return true;
      } else if (this.uploadType == 1 && ext == "MP4") {
        return true;
      }
      this.$toast("不支持该文件格式");
      return false;
    },
    //读取md5码方法
    getFileMd5(file) {
      return new Promise((resolve) => {
        let reader = new FileReader();
        let Spark = new SparkMD5.ArrayBuffer();
        reader.readAsArrayBuffer(file);
        reader.onload = function (e) {
          Spark.append(e.target.result);
          var md5 = Spark.end();
          // console.log(md5);
          resolve(md5);
        };
      });
    },
    //http-request覆盖默认的上传行为，可以自定义上传的实现上传一个文件
    async uploadFile(http) {
      // console.log("start upload...");
      // 上传进度
      this.progress = 0;
      this.pass = false;
      this.progShow = false;

      var file = http.file;
      const md5 = await this.getFileMd5(file);

      if (!md5) {
        this.$toast("md5读取失败");
        this.progShow = true;
        return;
      }

      //通过md5码向服务器查询上传情况
      //upload/getchunk
      var res = await this.WXPstAxios({
        method: "get",
        url: "/upload/getchunk",
        params: {
          FileSize: file.size,
          FileMd5: md5,
        },
      });
      //检查是否获取正确
      if (!(res.status && res.status == 200)) {
        this.$toast("上传查询失败");
        this.progShow = true;
        return;
      }
      //开始上传文件
      //console.log(res.data, file, md5)
      this.uploadStart(res.data, file, md5);
    },
    //文件上传方法
    async uploadStart(data, file, md5) {
      //取上传文件类型，防止此值在上传循环中出现变化。
      var contentType = this.uploadType;
      //兼容方式获取slice方法
      var blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;

      //循环发送切片数据
      for (var i = 0; i < data.chunkList.length; i++) {
        var chunk_index = data.chunkList[i];
        //取切片数据
        var start = chunk_index * data.chunkSize;
        var end = Math.min(start + data.chunkSize, file.size);
        var chunk = blobSlice.call(file, start, end);
        //向服务器发送切片数据
        let fd = new FormData(); // FormData 对象
        fd.append("FileName", file.name);
        fd.append("FileSize", file.size);
        fd.append("FileMd5", md5);
        fd.append("ChunkIdx", chunk_index);
        fd.append("ChunkSize", end - start);
        fd.append("ChunkCount", data.chunkCount);
        fd.append("ChunkFile", chunk); // 文件切片内容
        fd.append("ContentType", contentType); // 文件对象

        // 开始上传切片数据
        var res = await this.WXPstAxios({
          headers: {
            "Content-Type": "multipart/form-data",
          },
          method: "post",
          url: "/upload/postchunk/" + this.nodeId,
          data: fd,
          timeout: 80000,
        }).catch((err) => {
          var message = "上传失败";
          if (err.response && err.response.data) {
            message = err.response.data.Message;
          }
          //console.log('error:',message)
          this.progShow = true;
          this.$toast(message);
          return;
        });

        //
        if (res.status && res.status == 200) {
          this.progress = Math.floor((end / file.size) * 100);
          //console.log("succes:"+res.data)
          if (res.data) {
            this.pass = true;
            this.$toast("上传成功");
            this.getUploads();
          }
        }
      }
      this.progShow = true;
    },
    //
    contentShow(item) {
      this.docurls = [];
      this.fileExt = item.extName;
      if (item.extName == ".MP4") {
        var url =
          this.WXPstAxios_BASE_URL +
          "/upload/video/" +
          item.id +
          "?token=" +
          this.pstApi.getToken();
        this.docurls.push(url);
      } else {
        var pre = [];
        var back = [];
        var isback = false;
        this.dataList.forEach((img) => {
          var url =
            this.WXPstAxios_BASE_URL +
            "/upload/image/" +
            img.id +
            "?token=" +
            this.pstApi.getToken();
          if (item == img) {
            isback = true;
          }
          if (isback == false) {
            pre.push(url);
          } else {
            back.push(url);
          }
        });
        this.docurls = back;
        this.docurls = this.docurls.concat(pre);
      }
      //console.log(this.docurls);
    },
    //编辑上传文件信息
    editContent(item, i) {
      //修改名字
      this.isEditDoc = true;
      //
      this.form.id = item.id;
      this.form.title = item.title;
      this.form.ordernum = item.orderNum;
      this.form.contentType = item.contentType;
      this.form.checkList = [];
      //
      var parameters = JSON.parse(item.parameters);
      if (item.contentType == 0) {
        this.form.isPrint = true;
        if (parameters.IsPrint) {
          this.form.checkList.push("打印");
        }
      } else {
        this.form.isPrint = false;
      }
      if (parameters.IsDownload) {
        this.form.checkList.push("下载");
      } else if (item.contentType == 1) {
        this.form.checkList.push("下载");
      }
    },
    deleteUpload(item, i) {
      this.$confirm("是否删除此文件？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //可添加ajax
          this.WXPstAxios({
            method: "delete",
            url: "/upload/delete/" + item.id,
          }).then(() => {
            this.$toast("删除成功");
            this.getUploads();
          });
          //
        })
        .catch((meg) => console.log(meg));
    },
    //编辑文档 确定 按钮
    //修改上传文件基本信息
    handleClose() {
      this.isEditDoc = false;
      var parameters = {
        IsPrint: this.form.checkList.indexOf("打印") >= 0,
        IsDownload: this.form.checkList.indexOf("下载") >= 0,
        IsPlay: this.form.checkList.indexOf("自动播放") >= 0,
      };
      // console.log(parameters);
      var title = this.form.title;
      var orderNum = parseInt(this.form.ordernum);
      var parameter = JSON.stringify(parameters);
      if (title == "" || !this.Common.isInt(orderNum)) {
        this.$toast("数据填写错误");
        return false;
      }

      this.WXPstAxios({
        method: "put",
        url: "/upload/update/" + this.form.id,
        data: {
          Title: title,
          OrderNum: orderNum,
          Parameters: parameter,
        },
      }).then(() => {
        this.$toast("修改成功");
        this.getUploads();
      });
    },
    //编辑文档 取消 按钮
    cancelForm() {
      this.isEditDoc = false;
    },
    docViewClose() {
      this.docurls = [];
      this.fileExt = "";
    },
  },
};
</script>
<style lang="less" scoped>
.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
//
.img-list {
  overflow: hidden;
  width: 100%;
  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 100px; //200px;
    height: 170px; //270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 90px; //190px;
      margin: 0 auto;
      border-radius: 4px;
    }
    // 底部
    .img-li-b--bottom {
      margin-top: 10px;
      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }
    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }
    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 100px; //200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 40px; //80px;
      }
    }
    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }
    // 悬浮可见删除 or 放大按钮
    &:hover {
      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }
    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 100px; //200px;
    height: 170px; //270px;
    display: table;
    text-align: center;
    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}
/deep/.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  line-height: 100px;
  vertical-align: top;
}

.img-list_disabled {
  overflow: hidden;
  width: 100%;
  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 100px; //200px;
    height: 135px; //235px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 90px; //190px;
      margin: 0 auto;
      border-radius: 4px;
    }
    // 底部
    .img-li-b--bottom {
      margin-top: 10px;
      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }
    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }
    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 100px; //200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 40px; //80px;
      }
    }
    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }
    // 悬浮可见删除 or 放大按钮
    &:hover {
      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }
    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 100px; //200px;
    height: 170px; //270px;
    display: table;
    text-align: center;
    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}
.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;
  .el-button {
    flex: 1;
  }
}
</style>